































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Input from '@/components/common/elements/Input.vue';
import { SummaryViewType, Tax } from '@/constants/components/detailsSummaryArea';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';

@Component({
  components: { Label, SingleText, Input, InputNoVModel }
})
export default class DetailsSummaryArea extends Vue {
  // 項目名ラベルのname属性
  @Prop({ default: '' })
  private labelName!: string;
  // 項目名ラベル内テキスト
  @Prop({ default: '' })
  private labelText!: string;
  // 項目名追加付与クラス
  @Prop({ default: '' })
  private labelClass?: string;
  // 要素タイプ
  @Prop({ default: 'text' })
  private inputType?: string;
  // 集計に使用するデータ
  @Prop({ default: '' })
  private mainData: any;
  // 集計するデータに使用するプロパティ名
  @Prop({ default: '' })
  private mainDataPropertyName!: string;
  // 集計に使用するデータ
  @Prop({ default: '' })
  private subData: any;
  // 集計するデータに使用するプロパティ名
  @Prop({ default: '' })
  private subDataPropertyName!: string;
  // 表示タイプ(合算、税表示、粗利率など)
  @Prop({ default: '' })
  private viewType!: string;
  //集計後に使用するデータ
  @Prop({ default: 0 })
  private optionalData?: number;
  // 単位表示のテキスト
  @Prop({ default: '' })
  private unitText!: string;
  // 単位表示位置
  @Prop({ default: 'front' })
  private unitPosition?: string;
  // 入力要素最大入力数
  @Prop({ default: '' })
  private maxlength?: string;
  // 入力要素名
  @Prop({ default: '' })
  private inputName!: string;
  // 集計データ格納用index
  @Prop({ default: ''})
  private summaryAreaIndex!: string;
  // 小数点の位置
  @Prop({ default: 2})
  private decimalPointPosition!: number;
  // Inputの入力不可フラグ
  isReadOnlyFlag = true;
  // 表示する値
  public inputVal = '';

  /**
   * 親コンポーネントから設定された値を表示タイプごとに集計、
   * @module setSummaryValue
   * @param any data 集計するデータ
   * @param string propertyName 集計データに用いるプロパティ名
   * @return number 集計した値
   */
  private summaryDataSum(data: any, propertyName: string) {
    let value = 0;
    if( typeof(data) === 'string' || typeof(data) === 'number') {
      value += Number(data);
    } else {
      for (const key in data) {
        if (propertyName === '') {
          value += data[key];
        } else {
          value += data[key][propertyName];
        }
      }
    }
    return value;
  }

  /**
   * 親コンポーネントから設定された値を表示タイプごとに集計、
   * @module setSummaryValue
   * @return number 集計した値
   */
  private setSummaryValue() {
    let mainDataValue = 0;
    let subDataValue = 0;
    let valueData = 0;

    mainDataValue =
      isNaN(this.summaryDataSum(this.mainData, this.mainDataPropertyName))
        ? 0
        : this.summaryDataSum(this.mainData, this.mainDataPropertyName);
    subDataValue =
      isNaN(this.summaryDataSum(this.subData, this.subDataPropertyName))
        ? 0
        : this.summaryDataSum(this.subData, this.subDataPropertyName);
    switch (this.viewType) {
      case SummaryViewType.TOTAL:
        valueData = mainDataValue + subDataValue;
        this.inputVal = String(valueData.toLocaleString());
        break;
      case SummaryViewType.CONSUMPTIONTAXONLY:
        valueData = (mainDataValue + subDataValue) * Number(Tax.CONSUMPTIONTAX10);
        this.inputVal = String(valueData.toLocaleString());
        break;
      case SummaryViewType.CONSUMPTIONTAXINCLUDED:
        valueData = (mainDataValue + subDataValue) * (1 + Number(this.optionalData));
        this.inputVal = String(valueData.toLocaleString());
        break;
      case SummaryViewType.COSTRATE:
        if (subDataValue !== 0)
          valueData = mainDataValue / subDataValue * 100;
        this.inputVal = String(valueData.toFixed(this.decimalPointPosition));
        break;
      case SummaryViewType.GROSSPROFITMARGIN:
        if (subDataValue !== 0)
          valueData = mainDataValue / subDataValue * 100;
        this.inputVal = String(valueData.toFixed(this.decimalPointPosition));
        break;
      default:
    }

    this.detailsSummaryAreaOperation({labelText:this.labelText, value:String(valueData), index:String(this.summaryAreaIndex)})
    return this.inputVal;
  }

  /**
   * 親コンポーネントにlabelText(表示名)、
   * 値、index(パネル側で複数表示)を通知する
   * @module detailsSummaryAreaOperation
   * @param {[k: string]: string} data - labelTextと値
   * @return {[k: string]: string} data - labelTextと値
   */
  @Emit('detailsSummaryAreaOperation')
  public detailsSummaryAreaOperation(data:{labelText:string, value: string, index: string}) {
    return data;
  } 
}
